import React, { useEffect, useState, Fragment } from 'react';
const KEY = 'cv360_countdown_target';
const DURATION = 30 * 60 * 1000;
function safeGet(): string | null {
  try {
    if (typeof window === 'undefined') return null;
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}
function safeSet(val: string) {
  try {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(KEY, val);
  } catch {
    /* ignore — sandboxed iframes can block localStorage */
  }
}
function getInitialTarget(): number {
  const stored = safeGet();
  if (stored) {
    const n = parseInt(stored, 10);
    if (!Number.isNaN(n) && n > Date.now()) return n;
  }
  const target = Date.now() + DURATION;
  safeSet(String(target));
  return target;
}
export function CountdownTimer() {
  const [target, setTarget] = useState<number>(() => Date.now() + DURATION);
  const [remaining, setRemaining] = useState<number>(DURATION);
  useEffect(() => {
    const t = getInitialTarget();
    setTarget(t);
    setRemaining(Math.max(0, t - Date.now()));
    const id = setInterval(() => {
      setRemaining(Math.max(0, t - Date.now()));
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const totalSec = Math.floor(remaining / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor(totalSec % 3600 / 60);
  const s = totalSec % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="flex justify-center items-end gap-2 sm:gap-3" data-id="element-64">
      {[{
      label: 'HS',
      val: pad(h)
    }, {
      label: 'MIN',
      val: pad(m)
    }, {
      label: 'SEG',
      val: pad(s)
    }].map((u, i) => <Fragment key={u.label} data-id="element-65">
          <div className="flex flex-col items-center" data-id="element-66">
            <div className="bg-slate-900 text-white font-extrabold text-2xl sm:text-4xl tabular-nums rounded-lg px-3 sm:px-4 py-2 sm:py-3 min-w-[60px] sm:min-w-[80px] text-center shadow-lg" data-id="element-67">
              {u.val}
            </div>
            <span className="text-[10px] sm:text-xs font-bold text-slate-600 mt-1 tracking-widest" data-id="element-68">
              {u.label}
            </span>
          </div>
          {i < 2 && <span className="text-2xl sm:text-4xl font-extrabold text-slate-900 pb-6" data-id="element-69">
              :
            </span>}
        </Fragment>)}
    </div>;
}